var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComputerCheck2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.999 10c-.008 2.626-.086 4.043-.813 5.081a4.5 4.5 0 01-1.105 1.105C17.92 17 16.28 17 13 17H9c-3.28 0-4.919 0-6.081-.814a4.5 4.5 0 01-1.105-1.105C1 13.92 1 12.28 1 9c0-3.28 0-4.919.814-6.081a4.5 4.5 0 011.105-1.105C4.08 1 5.72 1 9 1h1.5",
    stroke: "#10c98f",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 14A1.6 1.6 0 004 12.4M8.8 14A4.8 4.8 0 004 9.2m8 4.8a8 8 0 00-8-8",
    stroke: "#10c98f",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5s1 0 2 2c0 0 3.177-5 6-6",
    stroke: "#10c98f",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17v4",
    stroke: "#10c98f",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21h8",
    stroke: "#10c98f",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
export default SvgIconComputerCheck2;